import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RedirectCommand, ResolveFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { FORMS_SECURE_UPLOAD_URL } from '@app/providers/forms-secure-upload-config/forms-secure-upload-config.token';
import { ERROR_ROUTE } from '@shared/types/error-route.const';
import { SigningErrorPagePath } from '@app/shared/types/signing-error-page-path.enum';

export const secureUploadExternalResolver: ResolveFn<RedirectCommand | undefined> = (
  route: ActivatedRouteSnapshot
) => {
  const router = inject(Router);
  const id = (route.paramMap.get('id') ?? route.queryParams['id']) as string | undefined;

  if (!id) {
    return of(
      new RedirectCommand(router.parseUrl(`${ERROR_ROUTE}/${SigningErrorPagePath.NotFound}`))
    );
  }

  const formsSecureUploadUrl = inject(FORMS_SECURE_UPLOAD_URL);
  window.location.href = formsSecureUploadUrl.replace('{0}', encodeURIComponent(id));

  return of();
};
